import {
  VIDEO_AREA_SIZE_LARGE_TYPE,
  VIDEO_AREA_SIZE_MEDIUM_TYPE,
  VIDEO_AREA_SIZE_SMALL_TYPE,
} from "@/content-hub/theme/themes/hazel/blocks/media/video-with-title/video-with-title-settings";

export const MAX_WIDTHS = {
  [VIDEO_AREA_SIZE_SMALL_TYPE]: 808,
  [VIDEO_AREA_SIZE_MEDIUM_TYPE]: 1224,
  [VIDEO_AREA_SIZE_LARGE_TYPE]: 1440,
};

export const VIDEO_GRID_LAYOUTS = {
  STANDARD: "STANDARD",
  CAROUSEL: "CAROUSEL",
  FEATURED: "FEATURED",
  PLAYLIST: "PLAYLIST",
} as const;

export const VIDEO_DATA = [
  {
    id: "UmVjb3JkaW5nVXBsb2FkOjY3",
    title: "RingCentral Recording 1, RingCentral Recording 1",
    thumbnail:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/64ad1c884f366c0001e6b520.jpeg?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
    playableUrl:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/index.m3u8?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
  },
  {
    id: "UmVjb3JkaW5nVXBsb2FkOY4",
    title: "RingCentral Recording 2",
    thumbnail:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/64ad1c884f366c0001e6b520.jpeg?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
    playableUrl:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/index.m3u8?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
  },
  {
    id: "UmVjb3JkaW5nVXBsb2FkjY5",
    title: "RingCentral Recording 3",
    thumbnail:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/64ad1c884f366c0001e6b520.jpeg?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
    playableUrl:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/index.m3u8?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
  },
  {
    id: "UmVjb3JkaW5nVXBsb2FOjY6",
    title: "RingCentral Recording 4",
    thumbnail:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/64ad1c884f366c0001e6b520.jpeg?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
    playableUrl:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/index.m3u8?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
  },
  {
    id: "UmVjb3JkaW5nVXBsb2kOjY7",
    title: "RingCentral Recording 5",
    thumbnail:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/64ad1c884f366c0001e6b520.jpeg?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
    playableUrl:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/index.m3u8?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
  },
  {
    id: "UmVjb3JkaW5nVXBsbFkOjY8",
    title: "RingCentral Recording 6",
    thumbnail:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/64ad1c884f366c0001e6b520.jpeg?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
    playableUrl:
      "https://videocdn.static.staging.events.ringcentral.com/playbacks/a0abcd7a-5525-4b5c-95b4-08abc76c5874/index.m3u8?token=eyJhbGciOiJIUzI1NiJ9.eyJhc3NldElkIjoiMmZhOWE0NjAtZGQ0Yy00MGRlLWJmNDQtMGM1ZWUwMjFkNTkyIiwicGxheWJhY2tJZCI6ImEwYWJjZDdhLTU1MjUtNGI1Yy05NWI0LTA4YWJjNzZjNTg3NCJ9.6ZiqJ45IN7ns6eZOzmSHM2S11sYZWLIrk4la8oCjaLU",
  },
];
